import { isEmpty } from "helpers";
import { LoginResult } from "operations/schema/schema";

export type User = Omit<LoginResult, "token" | "expiry">;
export const getInitialUserState = (): User | null => {
  const getDataFromLocalStorage = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return isEmpty(getDataFromLocalStorage)
    ? null
    : {
        ...getDataFromLocalStorage,
      };
};

/** 08.12.22
export type LoginResult = {
  __typename?: 'LoginResult';
  // The email of the logged in user
  email: Scalars['String'];
  // Token expiry
  expiry: Scalars['DateTime'];
  // The external GUID of the logged in user
  technicianGuid?: Maybe<Scalars['ID']>;
  // The external id of the logged in user
  technicianId: Scalars['String'];
  // The full name of the logged in user
  fullName?: Maybe<Scalars['String']>;
  // The id of the logged in user
  id: Scalars['String'];
  // The user prefered language
  languageCode?: Maybe<Scalars['String']>;
  // The product the user is assigned to
  product: Scalars['String'];
  // The technician own stock id
  stockId?: Maybe<Scalars['String']>;
  // JWT
  token: Scalars['String'];
  // User's consents
  userConsents: Array<UserConsentType>;
};
*/
